import { useMutation } from '@apollo/client';
import useEnableFastifyApi from './useEnableFastifyApi';
import { BOOK_FLIGHT } from '../mutations';
import restRequest from './restClient';
import useAsyncCall from './useAsyncCall';

function toGraphqlShape(bffResponse) {
  return { bookFlight: bffResponse };
}

function toRestBody({ heldConfirmInput, paymentInput }) {
  return { ...heldConfirmInput, paymentInput };
}

export default function useBookFlight(options) {
  const enableFastifyApi = useEnableFastifyApi();

  const graphqlResult = useMutation(BOOK_FLIGHT, options);
  const [restExecute, restState] = useAsyncCall(
    ({ variables } = {}) =>
      restRequest({
        method: 'POST',
        path: '/air-api/v1/flights/book',
        body: toRestBody(variables ?? {}),
      }).then(toGraphqlShape),
    options,
  );

  if (enableFastifyApi) {
    return [restExecute, restState];
  }
  return graphqlResult;
}
